// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductItem_wrapper__YBEZx","image":"ProductItem_image__uyFEu","info":"ProductItem_info__c4e82","price":"ProductItem_price__3ToDl"};